import { ILineSet } from "@/domain/entities/lineInfo";
import { ref } from "vue";

export const useLineSetMap = () => {
  const lineSetMap = ref(new Map<string, ILineSet>());

  const updateLineSetMap = (lineSets: ILineSet[]) => {
    lineSets.forEach((lineSet) => {
      const { lineSetCodeUid: uid } = lineSet;

      if (!lineSetMap.value.has(uid)) {
        lineSetMap.value.delete(uid);
      }

      lineSetMap.value.set(uid, lineSet);
    });
  };

  return {
    lineSetMap,
    updateLineSetMap,
  };
};
